/* eslint-disable react/prop-types */
import React from 'react'
import ReactHTMLParser, { DOMNode, Element } from 'html-react-parser'
import { useConfig } from 'msp-integrations'
import {
  default as RichTextComponentTypes,
  RichTextTextColors
} from './RichTextComponent.types'
import * as RichTextComponentStyles from './RichTextComponent.styles'
import getBackgroundColor from '../../../types/BackgroundColor'

const ContentHolder = (
  props: React.PropsWithChildren<{ className: string }>
) => {
  const {
    theme: {
      font: { regular: font }
    }
  } = useConfig()
  return <div className={`${props.className} ${font}`}>{props.children}</div>
}

class BaseRichTextComponent extends React.Component {
  color
  bgColor
  className

  parserOptions = {
    replace: (domNode: DOMNode) => {
      if (domNode && domNode.type === 'tag') {
        return this.handleTag(domNode as Element)
      }

      return false
    }
  }

  constructor(props: RichTextComponentTypes) {
    super(props)
    const { data, className = '' } = props
    const { textColor = 'black', hasCustomStyle, inheritFont } = data || {}
    this.color = RichTextTextColors[textColor]
    const { bgColor } = data || {}
    this.bgColor = getBackgroundColor(bgColor)

    if (!hasCustomStyle) {
      this.className = [
        RichTextComponentStyles.Default,
        inheritFont || 'text-16 leading-24 tracking-0.6',
        inheritFont || this.color,
        className,
        this.bgColor
      ]
    } else {
      this.className = [this.color, className, this.bgColor]
    }
  }

  render() {
    const { data } = this.props as RichTextComponentTypes
    const { richText = { value: '' } } = data
    return (
      <ContentHolder className={this.className.join(' ')}>
        {ReactHTMLParser(richText.value || '', this.parserOptions)}
      </ContentHolder>
    )
  }

  handleTag(element: Element) {
    if (element.name === 'a') {
      return this.handleLinkTag(element)
    }

    if (element.name === 'ul') {
      return this.handleList(element)
    }

    return false
  }

  handleLinkTag(element: Element) {
    // Link TAG should be overridden if necessary
    return element
  }

  handleList(element: Element) {
    // List TAG should be overridden if necessary
    return element
  }
}

export default BaseRichTextComponent
